import { render, staticRenderFns } from "./NewNgbTeamMembersEdit.vue?vue&type=template&id=99e39d06"
import script from "./NewNgbTeamMembersEdit.vue?vue&type=script&lang=js"
export * from "./NewNgbTeamMembersEdit.vue?vue&type=script&lang=js"
import style0 from "./NewNgbTeamMembersEdit.vue?vue&type=style&index=0&id=99e39d06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports